import { render } from "./IGCSETeacher.vue?vue&type=template&id=291604a4&scoped=true"
import script from "./IGCSETeacher.vue?vue&type=script&lang=js"
export * from "./IGCSETeacher.vue?vue&type=script&lang=js"

import "./IGCSETeacher.vue?vue&type=style&index=0&id=291604a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291604a4"]])

export default __exports__